import api from '../lib/api';

export const announcementService = {
  // Récupérer toutes les annonces avec pagination et filtres
  getAnnouncements: (params = {}) => {
    const queryParams = new URLSearchParams({
      page: params.page || 1,
      limit: params.limit || 10,
      ...(params.search && { search: params.search }),
      ...(params.type && { type: params.type }),
      ...(params.sortBy && { sortBy: params.sortBy }),
      ...(params.sortOrder && { sortOrder: params.sortOrder }),
      ...(params.actif !== undefined && { actif: params.actif })
    });

    return api.get(`/announcements?${queryParams}`);
  },

  // Récupérer une annonce par ID
  getAnnouncementById: (id) => {
    return api.get(`/announcements/${id}`);
  },

  // Créer une nouvelle annonce
  createAnnouncement: (data) => {
    return api.post('/announcements', data);
  },

  // Mettre à jour une annonce
  updateAnnouncement: (id, data) => {
    return api.put(`/announcements/${id}`, data);
  },

  // Supprimer une annonce
  deleteAnnouncement: (id) => {
    return api.delete(`/announcements/${id}`);
  },

  // Récupérer les commentaires d'une annonce
  getComments: (announcementId, params = {}) => {
    const queryParams = new URLSearchParams({
      page: params.page || 1,
      limit: params.limit || 10
    });

    return api.get(`/announcements/${announcementId}/comments?${queryParams}`);
  },

  // Ajouter un commentaire
  addComment: (announcementId, comment) => {
    return api.post(`/announcements/${announcementId}/comments`, {
      commentaire: comment
    });
  },

  // Récupérer les statistiques (Admin/RH/Manager)
  getStats: () => {
    return api.get('/announcements/stats');
  }
};

export default announcementService;
